export const REQUEST_UPDATE_DATA_FINISHED = "REQUEST_UPDATE_DATA_FINISHED";
export const REQUEST_ADD_DATA_FINISHED = "REQUEST_ADD_DATA_FINISHED";

export const REQUEST_CREATE_ORDER_AND_USER_FINISHED =
  "REQUEST_CREATE_ORDER_AND_USER_FINISHED";
export const PRE_CREATE_ORDER_AND_USER = "PRE_CREATE_ORDER_AND_USER";
export const REQUEST_CREATE_ORDER_AND_USER = "REQUEST_CREATE_ORDER_AND_USER";
export const CREATE_ORDER_AND_USER = "CREATE_ORDER_AND_USER";

export const PRE_FETCH_PRODUCTS_CART = "PRE_FETCH_PRODUCTS_CART";
export const REQUEST_FETCH_PRODUCTS_CART = "REQUEST_FETCH_PRODUCTS_CART";
export const REQUEST_FETCH_PRODUCTS_CART_FINISHED =
  "REQUEST_FETCH_PRODUCTS_CART_FINISHED";
export const FETCH_PRODUCTS_CART = "FETCH_PRODUCTS_CART";

export const SEND_ORDER = "SEND_ORDER";
export const PRE_SEND_ORDER = "PRE_SEND_ORDER";
export const REQUEST_SEND_ORDER = "REQUEST_SEND_ORDER";
export const REQUEST_SEND_ORDER_FINISHED = "REQUEST_SEND_ORDER_FINISHED";

export const REQUEST_CREATE_ORDER_FINISHED = "REQUEST_CREATE_ORDER_FINISHED";
export const REQUEST_CREATE_ORDER = "REQUEST_CREATE_ORDER";
export const PRE_CREATE_ORDER = "PRE_CREATE_ORDER";
export const CREATE_ORDER = "CREATE_ORDER";

export const CALL_FUNCTION_PAYMENT = "CALL_FUNCTION_PAYMENT";
export const INIT_FUNCTION_PAYMENT = "INIT_FUNCTION_PAYMENT";

export const PAYMENT_MADE = "PAYMENT_MADE";

export const REQUEST_ADD_COMMENTS_FINISHED = "REQUEST_ADD_COMMENTS_FINISHED";
export const REQUEST_ADD_COMMENTS = "REQUEST_PRE_ADD_COMMENTS";
export const PRE_ADD_COMMENTS = "PRE_ADD_COMMENTS";
export const ADD_COMMENTS = "ADD_COMMENTS";

export const REQUEST_PREPARATION_TIME_CHOSEN =
  "REQUEST_PREPARATION_TIME_CHOSEN";
export const PRE_PREPARATION_TIME_CHOSEN = "PRE_PREPARATION_TIME_CHOSEN";
export const PREPARATION_TIME_CHOSEN = "PREPARATION_TIME_CHOSEN";
export const REQUEST_PREPARATION_TIME_CHOSEN_FINISHED =
  "REQUEST_PREPARATION_TIME_CHOSEN_FINISHED";

export const CALL_CALCUL_HOUR = "CALL_CALCUL_HOUR";
export const INIT_CALCUL_HOUR = "INIT_CALCUL_HOUR";

export const SEND_SESSION_PAY_PLUS = "SEND_SESSION_PAY_PLUS";

export const PRE_FETCH_ORDER_DATA = "PRE_FETCH_ORDER_DATA";
export const REQUEST_FETCH_ORDER_DATA = "REQUEST_FETCH_ORDER_DATA";
export const REQUEST_FETCH_ORDER_DATA_FINISHED =
  "REQUEST_FETCH_ORDER_DATA_FINISHED";
export const FETCH_ORDER_DATA = "FETCH_ORDER_DATA";
export const INIT_ORDER = "INIT_ORDER";
export const RESET_ORDER_TIME = "RESET_ORDER_TIME";
